import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section" style={{ minHeight: '96vh' }}>
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="🧳 Hotel Booking System"
              description="A comprehensive hotel and hostel booking platform with real-time availability, secure payment processing, user reviews, and booking management. Features include room search filters, interactive maps, and multi-language support for travelers worldwide."
              ghLink="https://github.com/kiennnd/hotel-booking-system"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="🔗 Blockchain Platform"
              description="A decentralized blockchain-based platform for secure transactions and smart contracts. Features include cryptocurrency wallet integration, transaction history, consensus mechanisms, and distributed ledger technology for transparent and immutable record keeping."
              ghLink="https://github.com/kiennnd/blockchain-platform"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="📰 Digital News Portal"
              description="A modern digital news portal with real-time article publishing, category management, user comments, and social media integration. Features include responsive design, SEO optimization, search functionality, and content management system for journalists and editors."
              ghLink="https://github.com/kiennnd/digital-news-portal"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Chat Application"
              description="A real-time chat application built with modern web technologies. Features include instant messaging, user authentication, and responsive design for seamless communication across devices."
              ghLink="https://github.com/kiennnd/chat-app"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Personal Blog"
              description="A modern blog platform built with React and Node.js. Features markdown support, dark mode, responsive design, and SEO optimization for better content management and user experience."
              ghLink="https://github.com/kiennnd/personal-blog"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Code Editor Online"
              description="An online code editor with syntax highlighting, auto-completion, and live preview. Supports multiple programming languages with features like code formatting and file management."
              ghLink="https://github.com/kiennnd/online-editor"             
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="E-commerce Platform"
              description="A full-stack e-commerce solution with user authentication, product management, shopping cart, payment integration, and admin dashboard. Built with modern technologies for optimal performance."
              ghLink="https://github.com/kiennnd/ecommerce-platform"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Task Management App"
              description="A collaborative task management application with features like project boards, team collaboration, deadline tracking, and progress monitoring. Perfect for team productivity."
              ghLink="https://github.com/kiennnd/task-manager"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Weather App"
              description="A responsive weather application that provides real-time weather information, forecasts, and location-based services. Features beautiful UI and accurate weather data from reliable APIs."
              ghLink="https://github.com/kiennnd/weather-app"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
